<template>
  <div>
    <h2 class="mb-4">Navigation</h2>
    <div v-if="navigation.length === 0" class="p-20 bg-grey-lightest inline-block">
      <i class="fas fa-sync fa-spin"></i>
    </div>
    <draggable v-else v-model="navigation"
               :options="{group:{name:'nav'}}" :move="hasChildren" :class="{dragging}"
               element="ul" class="primary list-reset inline-block bg-grey-lightest p-8"
               @start="dragging=true" @change="onChange($event)" @end="dragging=false">
      <li v-for="nav in navigation" :key="nav.id" class="cursor-move">
        {{ nav.text }}
        <draggable v-model="nav.children"
                   :options="{group:{name:'nav'}}"
                   element="ul" class="secondary list-reset ml-4 border-l-2 border-grey-light"
                   @start="dragging=true" @change="onChange($event)" @end="dragging=false">
          <li v-for="child in nav.children" :key="child.id" class="cursor-move">
            {{ child.text }}
            <draggable v-model="child.children"
                       :options="{group:{name:'nav'}}"
                       element="ul" class="tertiary list-reset ml-4 border-l-2 border-grey-light"
                       @start="dragging=true" @change="onChange($event, false)" @end="dragging=false">
              <li v-for="grandchild in child.children" :key="grandchild.id" class="cursor-move">
                {{ grandchild.text }}
              </li>
            </draggable>
          </li>
        </draggable>
      </li>
    </draggable>
    <div class="flex lg:flex-1 pt-4 lg:mt-0 justify-start self-start md:flex-none w-full">
      <button :class="buttonState" class="flex-no-shrink bg-blue-dark hover:bg-blue-darker border-blue-dark hover:border-blue-darker text-sm border-4 text-white py-1 px-2 rounded w-32" type="button" @click="saveChanges()">
        <i v-if="saving" class="fas fa-sync fa-spin"></i>
        <span v-else>Save Changes</span>
      </button>
      <button class="flex-no-shrink border-transparent border-4 text-blue-dark hover:text-blue-darkest text-sm py-1 px-2 rounded" type="button" @click="loadNavigation()">
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { api } from "arctic-vuejs-template";
import draggable from "vuedraggable";

export default {
  name: "contentOverview",
  components: {
    draggable
  },
  data() {
    return {
      changeCount: 0,
      dragging: false,
      navigation: [],
      saving: false
    };
  },
  computed: {
    buttonState() {
      if (this.saving) {
        return [
          "cursor-not-allowed",
          "opacity-50",
          "hover:bg-blue-dark",
          "hover:border-blue-dark"
        ];
      }
      return {};
    }
  },
  beforeMount() {
    this.loadNavigation();
  },
  methods: {
    hasChildren(evt) {
      if (evt.to.className.includes("primary")) return true;
      return evt.draggedContext.element.children.length === 0;
    },
    loadNavigation() {
      this.navigation = [];
      api.get("/navigation").then(response => {
        this.navigation = response.data;
      });
    },
    onChange(evt, supportsChildren = true) {
      if (evt.added) {
        console.log(evt);
        this.$set(evt.added.element, "moved", true);
        if (supportsChildren) {
          if (!evt.added.element.children) {
            this.$set(evt.added.element, "children", []);
          }
        } else {
          this.$delete(evt.added.element, "children");
        }
      }
    },
    onEnd(evt) {
      console.log(evt);
    },
    saveChanges() {
      this.saving = true;
      let weight = 0;
      this.navigation.forEach(nav => {
        if (nav.moved || nav.weight !== weight) {
          this.changeCount++;
          api
            .patch("/navigation/" + nav.id, {
              parent_id: null,
              weight: weight
            })
            .then(() => {
              this.changeCount--;
              if (this.changeCount === 0) this.saving = false;
            });
        }
        if (nav.children.length > 0) {
          let childWeight = 0;
          nav.children.forEach(subNav => {
            if (subNav.moved || subNav.weight !== childWeight) {
              this.changeCount++;
              api
                .patch("/navigation/" + subNav.id, {
                  parent_id: nav.id,
                  weight: childWeight
                })
                .then(() => {
                  this.changeCount--;
                  if (this.changeCount === 0) {
                    this.saving = false;
                  }
                });
            }
            if (subNav.children.length > 0) {
              let grandChildWeight = 0;
              subNav.children.forEach(terNav => {
                if (terNav.moved || terNav.weight !== grandChildWeight) {
                  this.changeCount++;
                  api
                    .patch("/navigation/" + terNav.id, {
                      parent_id: subNav.id,
                      weight: grandChildWeight
                    })
                    .then(() => {
                      this.changeCount--;
                      if (this.changeCount === 0) {
                        this.saving = false;
                      }
                    });
                }
                grandChildWeight++;
              });
            }
            childWeight++;
          });
        }
        weight++;
      });
    }
  }
};
</script>

<style>
.dragging > li > .secondary, 
.dragging > li > .secondary > li > .tertiary {
  min-height: 18px;
}
.dragging > li > .secondary {
  padding-bottom: 10px;
}
.dragging > li.sortable-ghost > .secondary,
.dragging > li > .secondary > li.sortable-ghost > .tertiary {
  min-height: 0;
  padding-bottom: 0;
}
.secondary li:before,
.tertiary li:before {
  content: "-";
  color: #b8b8b8;
  margin-right: 15px;
}
</style>
